import { render, staticRenderFns } from "./order-summary.vue?vue&type=template&id=cdaf091e"
var script = {}
import style0 from "./order-summary.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports